'use client'

import { useResponsiveSize } from "@/provider/useResponsiveSize"
import { SupportLangs } from "@/locales/SupportLangs"
import { ChevronDown } from "@/ui/icons/ChevronDown"
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, HeroUIProvider, SharedSelection, useDisclosure } from "@heroui/react"
import { useLocale } from "next-intl"
import Link from "next/link"
import { usePathname, useRouter } from "next/navigation"
import { useMemo, useState } from "react"
import NextImage from 'next/image'

export const LangurageSelect = (props: any = {}) => {
  const local = useLocale()
  const pathname = usePathname()
  const router = useRouter()

  const [selectedKeys, setSelectedKeys] = useState<SharedSelection>(new Set([local]));

  const langs = useMemo(
    () => SupportLangs.filter(item => item.key !== local),
    [selectedKeys]
  );


  const selectedValue = useMemo(
    () => SupportLangs.find(item => item.key === ([...selectedKeys as Set<string>])[0])?.label,
    [selectedKeys]
  );

  const { isOpen, onOpenChange } = useDisclosure()

  return (
    <HeroUIProvider navigate={router.push}>
      <Dropdown
        classNames={{
          content: "bg-gray-bg",
        }}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        <DropdownTrigger>
          <Button
            radius="full"
            data-open={isOpen}
            className="pl-0 pr-0 sm:pr-5 justify-center group min-w-9 sm:pl-5 w-9 sm:min-w-[180px] h-9 sm:h-10 sm:justify-between bg-gray-bg"
            endContent={<ChevronDown width={20} className="hidden sm:block group-data-[open=true]:rotate-180 transition-transform" />}
          >
            <span className="hidden sm:block">
              {selectedValue}
            </span>
            <NextImage className="block sm:hidden mx-auto" src="/icons/global.svg" width={22} height={22} loading="eager" alt="global" />
          </Button>
        </DropdownTrigger>
        <DropdownMenu
          aria-label="Single selection example"
          variant="flat"
          selectionMode="single"
          disallowEmptySelection
          selectedKeys={selectedKeys}
          onSelectionChange={setSelectedKeys}
        >
          {
            langs.map(item => <DropdownItem
              as={Link}
              href={pathname === '/' ? `/${item.key}` : pathname.replace(local, item.key)}
              className="hover:bg-seleced-bg"
              key={item.key}>
              {item.label}
            </DropdownItem>
            )
          }
        </DropdownMenu>
      </Dropdown>
    </HeroUIProvider >

  )

}